import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { ArrowDownIcon } from '@synergy/theme';
import { ReactNode } from 'react';
import { makeStyles } from '@mui/styles';

import { PoolTypography } from '../typography/pool-typography';

const useStyles = makeStyles(() => ({
    root: {
        borderBottom: '1px solid #979797',
        boxShadow: 'none',
        backgroundColor: 'inherit',
        marginBottom: 19,

        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
            marginBottom: 19,
        },
        '&$expanded:last-child': {
            marginBottom: 19,
        },
    },
    expanded: {},
    rounded: {
        '&:last-child': {
            borderRadius: 0,
        },
    },
    summaryRoot: {
        paddingLeft: 0,
        marginBottom: -1,
        minHeight: 30,
        '&$expanded': {
            minHeight: 30,
        },
    },
    summaryContent: {
        margin: 0,
        '&$expanded': {
            margin: 0,
        },
    },
    detailsRoot: {
        padding: 0,
    },
    headerText: {
        fontSize: 15,
        fontWeight: 'bold',
    },
    expandIcon: {
        padding: 6,
    },
}));

interface PoolAccordionProps {
    header: ReactNode;
    children: ReactNode;
}

/**
 *  @deprecated Use components-next Accordion
 */
export const PoolAccordion = (props: PoolAccordionProps) => {
    const classes = useStyles();

    return (
        <Accordion
            classes={{ root: classes.root, expanded: classes.expanded, rounded: classes.rounded }}
            className={classes.root}
        >
            <AccordionSummary
                expandIcon={<ArrowDownIcon />}
                classes={{
                    root: classes.summaryRoot,
                    content: classes.summaryContent,
                    expanded: classes.expanded,
                    expandIconWrapper: classes.expandIcon,
                }}
            >
                <PoolTypography className={classes.headerText}>{props.header}</PoolTypography>
            </AccordionSummary>
            <AccordionDetails classes={{ root: classes.detailsRoot }}>{props.children}</AccordionDetails>
        </Accordion>
    );
};
